import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  planzone: Boundaries["retrieveRoles"]["request"],
): State {
  return [
    ...state,
    { request: setRequestStateToPending(), planzone, roles: [] },
  ];
}

function handleSuccess(
  state: State,
  { planzone, roles }: Boundaries["retrieveRoles"]["success"],
): State {
  return state.map((res) =>
    res.planzone.uuid === planzone.uuid
      ? { ...res, request: setRequestStateToSuccess(), roles }
      : res,
  );
}

function handleFailure(
  state: State,
  { uuid }: Boundaries["retrieveRoles"]["failure"],
): State {
  return state.map((res) =>
    res.planzone.uuid === uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveRolesRequested]: handleRequest,
    [events.retrieveRolesSucceeded]: handleSuccess,
    [events.retrieveRolesFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
